import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";
import classnames from 'classnames';

import InputSearch from "../../ui/InputSearch/InputSearch";
import Arrows from "../../ui/Arrows/Arrows";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock"; 
import ConsultantItem from "./ConsultantItem/ConsultantItem"; 
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  changeConsultantsPage,
  changeConsultantsLimit,
  getConsultantsListAsync,
  changeConsultantsSearch,
  startConsultantsSearch,
  clearConsultantsSearch,
  changeConsultantsSorting,
} from "../../../redux/actions/consultantsList";

import { setListsPayload } from '../../../methods';

const mapStateToProps = state => ({
  ...state.consultantsList,
});

const mapDispatchToProps = dispatch => ({
  onClickConsultant: id => dispatch(push(`/consultant/${id}`)),
  onChangePage: page => dispatch(changeConsultantsPage(page)),
  onChangeDisplayOption: limit => dispatch(changeConsultantsLimit(limit)),
  getConsultantsList: payload => dispatch(getConsultantsListAsync(payload)),
  changeConsultantsSearch: value => dispatch(changeConsultantsSearch(value)),
  startConsultantsSearch: value => dispatch(startConsultantsSearch(value)),
  clearConsultantsSearch: () => dispatch(clearConsultantsSearch()),
  changeConsultantsSorting: (sort, order) => dispatch(changeConsultantsSorting(sort, order)),
});

class ConsultantsList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    consultants: PropTypes.array.isRequired,
    cons_total: PropTypes.number.isRequired,
    cons_limit: PropTypes.number.isRequired,
    cons_activePage: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    getConsultantsList: PropTypes.func.isRequired,
    onClickConsultant: PropTypes.func.isRequired,
    //Поиск
    changeConsultantsSearch: PropTypes.func.isRequired,
    startConsultantsSearch: PropTypes.func.isRequired,
    clearConsultantsSearch: PropTypes.func.isRequired,
    cons_search: PropTypes.string.isRequired,
    cons_activeSearch: PropTypes.string.isRequired,
    //Сортировка
    changeConsultantsSorting: PropTypes.func.isRequired,
    sorting: PropTypes.object.isRequired,
  };

  componentDidMount = () => { 
    const { getConsultantsList, cons_limit, cons_activePage, cons_activeSearch, sorting } = this.props;
    const payload = setListsPayload(cons_limit, cons_activePage, cons_activeSearch, sorting);
    getConsultantsList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { cons_limit, cons_activePage, cons_activeSearch, sorting, getConsultantsList } = this.props;
    const payload = setListsPayload(cons_limit, cons_activePage, cons_activeSearch, sorting);
    //Условия перезагрузки
    if (
      (previousProps.cons_activePage !== cons_activePage) 
      || (previousProps.cons_limit !== cons_limit)
      || ((previousProps.cons_activeSearch !== cons_activeSearch))
      || ((previousProps.sorting.sort !== sorting.sort))
      || ((previousProps.sorting.order !== sorting.order))
    ) getConsultantsList(payload);
  }

  //ПОИСК
  //Здесь поиск ведется по ID
  //Оставляем только цифры, латинские буквы и символы для email
  onChangeConsultantsSearch = (value) => {
    const { changeConsultantsSearch, clearConsultantsSearch } = this.props;
    value = value.replace(/[^A-Za-z0-9@_.]/g, '');
    (value.length !== 0) ? changeConsultantsSearch(value) : clearConsultantsSearch();
  }

  startConsultantsSearching = (value) => {
    const { cons_search, startConsultantsSearch } = this.props;
    //В строке поиска должен быть хотя бы один символ
    if ((value === 'Enter') && (cons_search.length !== 0)){
      startConsultantsSearch(cons_search);
    }
  }

  //СОРТИРОВКА
  onchangeConsultantsSorting = sortOption => {
    const { sorting, changeConsultantsSorting } = this.props;
    let order = true;
    if (sorting.sort === sortOption) order = !sorting.order;
    changeConsultantsSorting(sortOption, order);
  }

  renderConsultantsList = (item, i) => {
    const { onClickConsultant } = this.props; 
    return(
      <ConsultantItem key={`${item.id}_${i}`} consultant={item} onClickConsultant={onClickConsultant} />
    );
  }

  render() {
    const {
      ready, loading, consultants, cons_limit, cons_total, sorting, cons_activePage, onChangePage, onChangeDisplayOption,
      cons_search, clearConsultantsSearch,
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(cons_total / cons_limit);

    //Классы для сортировки
    const idClass = classnames({
      'header-item': true,
      'cons-id': true,
      'current': sorting.sort === 'id',
    });
  
    const dateClass = classnames({
      'header-item': true, 
      'cons-date': true,
      'current': sorting.sort === 'created_at',
    });
  
    const countClass = classnames({
      'header-item': true,
      'clients-count': true,
      'current': sorting.sort === 'count',
    });

    return(
      <div className="lists-wrap">
        <div className="lists-header">
          <InputSearch
            placeholder="Поиск по ID"
            value={cons_search}
            onChange={this.onChangeConsultantsSearch}
            onKeyUp={this.startConsultantsSearching}
            onClear={clearConsultantsSearch}
          />
        </div>
        {ready ? (
          <React.Fragment>
            <div className="lists-content consultants">
            <div className="lists-content-total">Консультанты ({cons_total})</div>
              <div className="list-header">
                <button
                  type="button"
                  className={idClass}
                  onClick={() => this.onchangeConsultantsSorting('id')}
                >
                  Номер ID
                  <Arrows
                    sortUp={(sorting.sort === 'id') && (sorting.order)}
                    sortDown={(sorting.sort === 'id') && (!sorting.order)}
                  />
                </button>
                <button
                  type="button"
                  className={dateClass}
                  onClick={() => this.onchangeConsultantsSorting('created_at')}
                >
                  Дата регистрации
                  <Arrows
                    sortUp={(sorting.sort === 'created_at') && (sorting.order)}
                    sortDown={(sorting.sort === 'created_at') && (!sorting.order)}
                  />
                </button>
                <button
                  type="button"
                  className={countClass}
                  onClick={() => this.onchangeConsultantsSorting('count')}
                >
                  Клиентов
                  <Arrows
                    sortUp={(sorting.sort === 'count') && (sorting.order)}
                    sortDown={(sorting.sort === 'count') && (!sorting.order)}
                  />
                </button>
              </div>
              {consultants.length !== 0 ? consultants.map(this.renderConsultantsList) : false}
            </div>
            <div className="lists-footer">
              {consultants.length !== 0 ? (
                <PaginationBlock
                  activePage={cons_activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[15, 30, 60, 120]}
                  selectedDisplayOption={cons_limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
                ) : false}
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(ConsultantsList));